<script setup>
import { computed } from 'vue';

import { 
  kPage, 
  kBlock,
} from 'konsta/vue';

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();

import {useConfig} from '@/stores/config'
const configStore = useConfig();

import StepNavigation from '@/components/StepNavigation.vue';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const today = new Date();

const closed_days = computed(_ => {
  if(!configStore.config.closed_days) return [];

  var disabled = [];
  for(const date of configStore.config.closed_days){
    var tmp = date.split('-');
    disabled.push(new Date(parseInt(tmp[0]), parseInt(tmp[1])-1, parseInt(tmp[2])));
  }

  return disabled;
})

</script>


<template>

  <k-block>
    <VueDatePicker 
      v-model="bookingStore.date_object" 
      :inline="{ input: false }" 
      :enable-time-picker="false"
      auto-apply
      locale="it" 
      :min-date="today"
      :disabled-dates="closed_days"
      class="w-full block"
      />
  </k-block>

  <StepNavigation/>

</template>

<style lang="scss">
.dp__theme_light {
  --dp-primary-color: var(--color-primary);
  --dp-background-color: transapent;
  --dp-menu-border-color: transapent;
  --dp-cell-border-radius: 50%;
}
</style>